import axios from 'axios';
import { httpClient } from '@/api/httpClient';
import { readBackendErrorCode } from '@/api/readBackendErrorCode';
import { WORKSPACE_EXPORT_NOT_FOUND_ERROR_CODE } from '@/constants/workspaceData';
import {
  mapApiResourceToWorkspaceExport,
  type WorkspaceExport,
  type WorkspaceExportApiResource,
  type WorkspaceExportDownloadApiResource,
} from './workspaceExportApi.types';

const WORKSPACE_EXPORT_PATH = '/me/workspace/data-export';

function isWorkspaceExportNotFound(caughtError: unknown): boolean {
  return (
    axios.isAxiosError(caughtError) &&
    caughtError.response !== undefined &&
    caughtError.response.status === 404 &&
    readBackendErrorCode(caughtError) === WORKSPACE_EXPORT_NOT_FOUND_ERROR_CODE
  );
}

export async function requestWorkspaceExport(): Promise<WorkspaceExport> {
  const response = await httpClient.post<WorkspaceExportApiResource>(WORKSPACE_EXPORT_PATH);
  return mapApiResourceToWorkspaceExport(response.data);
}

export async function fetchLatestWorkspaceExport(): Promise<WorkspaceExport | null> {
  try {
    const response = await httpClient.get<WorkspaceExportApiResource>(WORKSPACE_EXPORT_PATH);
    return mapApiResourceToWorkspaceExport(response.data);
  } catch (caughtError) {
    if (isWorkspaceExportNotFound(caughtError)) {
      return null;
    }
    throw caughtError;
  }
}

export async function fetchWorkspaceExportDownloadUrl(exportId: string): Promise<string> {
  const response = await httpClient.get<WorkspaceExportDownloadApiResource>(
    WORKSPACE_EXPORT_PATH + '/' + exportId + '/download'
  );
  return response.data.download_url;
}
